module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"title":"Napisz lub zadzwoń","contacts":{"email":"info@suninvestmentgroup.com","phone":"+48 734 218 786"}}}')
  delete Component.options._Ctor
}
